import Vue from 'vue'
import router from '@/router'
import carregarArquivoBalancete from './xlsx/balancete'
import { balancete as routing } from '@/util/routes'

export default {
  state: {
    balancete: {},
    balancetes: [],
    paginateBalancetes: { data: [] },
    tabelaBalancete: 'Balancete Mensal',
    balancetePage: 1,
    balanceteFilter: ''
  },
  mutations: {
    setBalancete: (state, payload) => {
      state.balancete = payload
    },
    setBalancetes: (state, payload) => {
      state.balancetes = payload
    },
    setPaginateBalancetes: (state, payload) => {
      state.paginateBalancetes = payload
    },
    setBalancetePage: (state, payload = 1) => {
      state.balancetePage = payload
    },
    setBalanceteFilter: (state, payload = '') => {
      state.balanceteFilter = payload
    }
  },
  actions: {
    async getPaginateBalancetes ({ commit, state }, payload) {
      commit('setPaginateBalancetes', {
        data: []
      })
      const { data } = await Vue.axios.get(`${routing}`, {
        headers: {
          page: state.balancetePage,
          filter: state.balanceteFilter
        }
      })
      commit('setPaginateBalancetes', data)
    },
    async getBalancete ({ commit }, { id }) {
      commit('setBalancete', {})
      const { data } = await Vue.axios.get(`${routing}/${id}`)
      commit('setBalancete', data)
    },
    async carregarBalancete ({ commit, state }, { file, visita }) {
      return carregarArquivoBalancete(file, async balancete => {
        balancete.visita_id = visita
        await Vue.axios.post(`${routing}`, balancete)
        alert('Balancete importado com sucesso.')
        return router.push({
          name: 'visitas-details',
          params: {
            id: visita
          }
        })
      })
    },
    async deleteBalancete ({ state }, { id }) {
      return Vue.axios.delete(`${routing}/${id}`)
    }
  },
  getters: {
    balancete: ({ balancete }) => balancete,
    balancetePage: ({ balancetePage }) => balancetePage,
    balanceteFilter: ({ balanceteFilter }) => balanceteFilter,
    balancetes: ({ balancetes }) => balancetes,
    paginateBalancetes: ({ paginateBalancetes }) => paginateBalancetes
  }
}
